import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchCartDetails } from "../redux/cartSlice";
import { useCartWishlist } from "../../../../app/CartWishlistContext";
import { checkPincode } from "../../../products/pdp/redux/pincodeSlice";

export const useCartPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { countData } = useCartWishlist();

    const [token] = useState(localStorage.getItem("token"));
    const lastErrorRef = useRef(null);

    const { cartItems, loading, error } = useSelector((state) => state.cart);

    useEffect(() => {
        document.title = "Obsessions - Cart";

        if (!token) {
            navigate("/login");
            return;
        }

        dispatch(fetchCartDetails());

        const storagePin = localStorage.getItem("pincode");
        if (storagePin) {
            dispatch(checkPincode(storagePin));
        }
    }, [dispatch, token, navigate]);

    useEffect(() => {
        if (token) dispatch(fetchCartDetails());
    }, [countData]);

    useEffect(() => {
        if (error && error !== lastErrorRef.current) {
            lastErrorRef.current = error;
        }
    }, [error]);

    return {
        items: cartItems?.items ?? [],
        mrpTotal: cartItems?.mrpTotal ?? 0,
        discountTotal: cartItems?.discountTotal ?? 0,
        total: cartItems?.total ?? 0,
        loading,
        token,
        breadcrumbPaths: [{ label: "Cart", to: "" }],
    };
};